<template>
    <v-btn-toggle
        :value="value"
        borderless
        tile
        :multiple="multiple"
        :background-color="backgroundColor"
        @change="$emit('change', $event)"
    >
        <!-- registered -->
        <IconBtn
            value="registered"
            color="primary"
            icon-cls="hourglass"
            :icon-color="iconColor"
            :icon-active-color="iconActiveColor"
            icon-disabled-color="white"
            :tooltip="$t('in_bearbeitung_tgk')"
            :margin-class="btnsMarginClass"
            :icon-size="iconsSize"
        />
        <!-- draft -->
        <IconBtn
            value="draft"
            color="primary"
            icon-cls="inwork"
            :icon-color="iconColor"
            :icon-active-color="iconActiveColor"
            icon-disabled-color="white"
            :tooltip="$t('in_bearbeitung_draft')"
            :margin-class="btnsMarginClass"
            :icon-size="iconsSize"
        />
        <!-- imported -->
        <IconBtn
            v-if="userIsStaff()"
            value="imported"
            color="primary"
            icon-cls="new-from"
            :icon-color="iconColor"
            :icon-active-color="iconActiveColor"
            icon-disabled-color="white"
            :tooltip="$t('neu_von_fremdsystem')"
            :margin-class="btnsMarginClass"
            :icon-size="iconsSize"
        />
        <!-- deleted -->
        <IconBtn
            v-if="!hideDeleted"
            value="deleted"
            color="primary"
            icon-cls="trash"
            :icon-color="iconColor"
            :icon-active-color="iconActiveColor"
            icon-disabled-color="white"
            :tooltip="$t('deleted')"
            :margin-class="btnsMarginClass"
            :icon-size="iconsSize"
        />
        <!-- rejected -->
        <IconBtn
            value="rejected"
            color="primary"
            icon-cls="rejected"
            :icon-color="iconColor"
            :icon-active-color="iconActiveColor"
            icon-disabled-color="white"
            :tooltip="$t('rejected')"
            :margin-class="btnsMarginClass"
            :icon-size="iconsSize"
        />
        <!-- released -->
        <IconBtn
            value="released"
            color="primary"
            icon-cls="like"
            :icon-color="iconColor"
            :icon-active-color="iconActiveColor"
            icon-disabled-color="white"
            :tooltip="$t('publiziert')"
            :margin-class="btnsMarginClass"
            :icon-size="iconsSize"
        />
    </v-btn-toggle>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { userIsStaff } from '@/helpers/auth';

export default defineComponent({
    name: 'StatusToggleBtns',
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [Array, String],
            default: null,
        },
        backgroundColor: {
            type: String,
            default: 'primary',
        },
        iconColor: {
            type: String,
            default: 'white',
        },
        iconActiveColor: {
            type: String,
            default: 'white',
        },
        hideDeleted: {
            type: Boolean,
            default: false,
        },
        btnsMarginClass: {
            type: String,
            default: '',
        },
        iconsSize: {
            type: String,
            default: '',
        },
        showRedigiert: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        userIsStaff,
    },
});
</script>
